
export default {
	props: {
		context: {
			type: Object,
			required: true
		},
	},

	data() {
		return {
			visible: null,
		};
	},
	computed: {
		passwordMaskStyle() {
			return {
				/* CSS mask for password characters */
				WebkitTextSecurity: 'disc',
				MozTextSecurity: 'disc',
				textSecurity: 'disc'
			}
		}
	}
};
